// extracted by mini-css-extract-plugin
export default {"projectsContainer":"Projects_projectsContainer__eHpD7","projectsTableContainer":"Projects_projectsTableContainer__oRCrc"};